"use client";
import type { requestTravelAction } from "@/actions/requestTravel";
import { SecondaryButton } from "ui/components";
import { RequestTravel } from "../../_components/RequestTravel";
import { useProductPageContext } from "../../_layout/ClientContext";
import type { Departures } from "../../getDepartures";
import type { Travel } from "../../getTravel";

type Props = {
  travel: Travel;
  departure: Departures[number];
  requestTravelAction: typeof requestTravelAction;
};
export const HandleReservation = ({ travel, departure, requestTravelAction }: Props) => {
  const { handleReservation } = useProductPageContext();
  const registrationStatus = departure.state.registrationStatus;

  return (
    <>
      {(registrationStatus === "open" || registrationStatus === "onDemand") && (
        <SecondaryButton
          onClick={() => handleReservation(departure)}
          className="w-full @3xl:px-0!"
          direction="up"
          size="sm"
        >
          Réserver ce voyage
        </SecondaryButton>
      )}
      {registrationStatus === "soon" && departure.versionId && (
        <RequestTravel
          travelId={travel.id}
          departureId={departure.id}
          travelTitle={travel.title}
          versionId={departure.versionId}
          requestTravelAction={requestTravelAction}
          onSuccess={() => {
            return;
          }}
        >
          <SecondaryButton className="w-full @3xl:px-0!" direction="up" size="sm">
            Recevoir une alerte
          </SecondaryButton>
        </RequestTravel>
      )}
    </>
  );
};
